/**
 * Utility functions for sidebar navigation
 */

/**
 * Check if a menu item URL is active based on the current path
 * 
 * @param url The URL to check
 * @param currentPath The current path (without leading slash)
 * @returns boolean indicating if the item is active
 */
export const isMenuItemActive = (url: string, currentPath: string): boolean => {
  // Handle special case for home page
  if (currentPath === '' && (url === '/' || url.includes('index'))) {
    return true;
  }
  
  // Convert URL to path for comparison
  const urlPath = url.replace(/^\//, '').split('?')[0]; // Remove leading slash and query params
  
  return currentPath === urlPath || currentPath.startsWith(urlPath + '/');
};

/**
 * Check if any item in a group is active
 * 
 * @param items Array of menu items
 * @param currentPath The current path (without leading slash)
 * @returns boolean indicating if any item in the group is active
 */
export const isGroupActive = (
  items: { url: string }[] | undefined,
  currentPath: string
): boolean => {
  if (!items || items.length === 0) return false;
  return items.some(item => isMenuItemActive(item.url, currentPath));
};
